/**
 * 获取编辑器的内容
 */
function getEditorContent(editor) {
  // 编辑器内HTML
  const html = editor.txt.html();
  // 编辑器内文本
  const text = editor.txt.text();
  // 编辑器内图片（非表情、非分割线图片）
  const imageList = Array.from(document.querySelectorAll('.edite-ement img:not(.facial-expression):not(.spaceline)'))
    .map(el => el.src)
    .filter(url => !((url || '').indexOf('data:') == 0 && (url || '').indexOf('base64') > 0));
  // 编辑器内所有视频
  const videoList = Array.from(document.querySelectorAll('.edite-ement iframe[src*="youtube.com"]')).map(el => el.src);

  // 编辑器内所有音频
  const audioList = [];
  // 编辑器内所有图片
  const images = Array.from(document.querySelectorAll('.edite-ement img')).map(el => el.src);
  // 编辑器是否有内容
  const haveContent = text.length > 0 || images.length > 0 || videoList.length > 0;

  return { html, text, imageList, videoList, audioList, haveContent };
}

// 上传图片超时时间
const UPLOAD_IMG_TIMEOUT = 90000;
const EMOJI_LIST = [
  "😊","😍","😮","😎","😭","😚","🤐","😴",
  "🥺","🥵","😡","😜","😮","🙁","😳","😖",
  "🤮","😄","😕","😔","😰","😆","🤠",
  "😠","🤫","😵‍","💀","😥","🤪","😕","😅",
  "😷","😲","😂","😱","😞","🥰","🤔","🤗",
  "😘","👿","👄","💏","👼","💍","👀","🙈",
  "❤","💔","👍","👎","💪","✊","🤝","✌",
  "👌","🙏","👏","🍺","🍻","🍹","☕","🦞",
  "🍞","🍕","🥩","🍔","🌭","🍟","🧀","🎂",
  "🍦","🍭","🎈","🍩","🍉","🍇","🍓","🥝",
  "🥑","🌹","🥀","🌸","🌻","🌲","🔪","💣",
  "👑","🎉","🎁","🧧","🎃","🧙‍♀️","🧛‍♀️","🎄",
  "🎅","🎀","🎇","🧨","🔥","☀","🌙","🌟",
  "🌈","⛄","❄","⏰","⌛","✈","🌎","⛵",
  "🚗","⛺","🏖","🍽","🐷","🐶","🐱","🐻‍❄️",
  "🐨","🐠","🦋","🐛","🦖","🚕","🚧","🚑",
  "🚒","🏎","🚲","🏀","⚽","🎯","🛍"
]
export { getEditorContent, UPLOAD_IMG_TIMEOUT,EMOJI_LIST };
